import editSchema from "../../getters/editSchema";

const tsDiagram = editSchema;

export default tsDiagram;
